/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = ({
  name: 'LoadingPage'
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-wrapper"},[_c('header',{staticClass:"p-header"},[_c('h1',{staticClass:"is-title-2 p-title"},[_c('img',{staticClass:"c-logo",attrs:{"src":"/assets/images/group-income-icon-transparent.png","alt":""}}),_vm._v(_vm._s(_vm.$route.meta.title))])]),_vm._m(0)])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"p-main"},[_c('div',{staticClass:"loading-box"}),_c('div',{staticClass:"loading-box"}),_c('div',{staticClass:"loading-box"})])}]

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0f1d4d2c_0", { source: ".p-wrapper[data-v-0f1d4d2c]{display:grid;grid-template-areas:\"p-header\" \"p-main\";grid-template-columns:1fr;grid-template-rows:auto minmax(0,1fr);height:100%;width:100vw}@media screen and (min-width:1200px){.p-wrapper[data-v-0f1d4d2c]{width:auto;grid-template-columns:minmax(0,1fr) 16.5rem;grid-template-areas:\"p-header p-sidebar\" \"p-main p-sidebar\"}}.p-main[data-v-0f1d4d2c]{grid-area:p-main;width:calc(100% - 2rem);margin:0 auto;padding-top:1.5rem;max-width:50rem;display:flex;flex-direction:column;-webkit-overflow-scrolling:touch}@media screen and (min-width:769px),print{.p-main[data-v-0f1d4d2c]{width:calc(100% - 4rem)}}@media screen and (min-width:1200px){.p-main[data-v-0f1d4d2c]{width:auto;padding-top:0;margin-right:2rem;margin-left:5.5rem}}.p-header[data-v-0f1d4d2c]{grid-area:p-header;transition:padding ease-out .3s;text-align:center;min-height:4rem}@media screen and (max-width:1199px){.p-header[data-v-0f1d4d2c]{display:flex;justify-content:center;align-items:center;position:sticky;top:0;background:var(--general_2);z-index:3}}@media screen and (min-width:1200px){.p-header[data-v-0f1d4d2c]{display:block;padding-top:1.125rem;text-align:left;min-height:4.75rem;padding-left:5.5rem}}.p-title[data-v-0f1d4d2c]{display:flex;align-items:center}.c-logo[data-v-0f1d4d2c]{width:1.5rem;height:1.5rem;margin-right:1rem}@media screen and (min-width:1200px){.c-logo[data-v-0f1d4d2c]{display:none}}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-0f1d4d2c"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__